import { computed, useRoute } from '#imports'

export const useTermsDialog = () => {
    const route = useRoute()

    const terms = computed(() => route.query.terms)
    const generalTerms = computed(() => (route.query['general-terms'] || terms.value) && !isPromotionTerms.value)
    const privacyPolicy = computed(() => route.query['privacy-policy'])
    const promotionId = computed(() => route.query.promotionId)
    const promotionReferenceId = computed(() => route.query.promotionReferenceId || route.query.referenceId)
    const bonusReferenceId = computed(() => route.query.bonusReferenceId)
    const excludedGames = computed(() => route.query['excluded-games'])
    const bingoGames = computed(() => route.query['bingo-games'])
    const jackpotGames = computed(() => route.query['jackpot-games'])

    const hasLegalTermsDialog = computed(() => terms.value || generalTerms.value || privacyPolicy.value)
    const hasPromotionTermsDialog = computed(() => promotionId.value || bonusReferenceId.value || promotionReferenceId.value)
    const hasGameTermsDialog = computed(() => excludedGames.value || bingoGames.value || jackpotGames.value)

    const isPromotionTerms = computed(() => hasPromotionTermsDialog.value)

    const isActive = computed(() => hasLegalTermsDialog.value || hasPromotionTermsDialog.value || hasGameTermsDialog.value)

    return {
        terms,
        generalTerms,
        privacyPolicy,
        promotionId,
        promotionReferenceId,
        bonusReferenceId,
        excludedGames,
        bingoGames,
        jackpotGames,
        isPromotionTerms,
        isActive,
    }
}
